import * as stylex from '@stylexjs/stylex'

import { breakpoints, colors, controlSizes, fonts, fontSizes, radii, spacing } from '../tokens/tokens.stylex'

export const actionStyles = stylex.create({
  control: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.space8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: radii.small,
    fontFamily: fonts.interface,
    fontSize: fontSizes.small,
    lineHeight: 1.3,
    fontWeight: 500,
    cursor: { default: 'pointer', ':disabled': 'not-allowed' },
    opacity: { default: 1, ':disabled': 0.5 },
    outline: { default: 'none', ':focus-visible': `2px solid ${colors.foreground}` },
    outlineOffset: 3,
  },
  md: { minHeight: 40, paddingInline: spacing.space16, paddingBlock: spacing.space8 },
  sm: {
    minHeight: { default: controlSizes.compact, [breakpoints.coarse]: controlSizes.touch },
    paddingInline: spacing.space12,
    paddingBlock: spacing.space4,
  },
})
